import { createStore } from '@xstate/store';
import { useSelector } from '@xstate/store/react';
import { useMemo } from 'react';

type Config = {
  activeLocationId: string | null;
};

export const useConfigStore = (tenantId?: string, userId?: string) => {
  const storageKey = ['eluve', 'config', tenantId, userId]
    .filter(Boolean)
    .join('-');

  const store = useMemo(() => {
    let initial: Config = { activeLocationId: null };
    try {
      const persisted = localStorage.getItem(storageKey);
      if (persisted) {
        const parsed = JSON.parse(persisted);
        initial = parsed.state?.config ?? parsed.config ?? initial;
      }
    } catch {
      // ignore parse errors
    }

    const s = createStore(
      { config: initial },
      {
        setConfig: (ctx: { config: Config }, event: { updated: Config }) => ({
          config: { ...ctx.config, ...event.updated },
        }),
      },
    );

    s.subscribe((snapshot) => {
      localStorage.setItem(storageKey, JSON.stringify(snapshot.context));
    });

    return s;
  }, [storageKey]);

  const config = useSelector(store, (s) => s.context.config);

  return {
    config,
    setConfig: (updated: Config) => store.send({ type: 'setConfig', updated }),
  };
};
